import { BYO_ADD_SELECTION, BYO_REMOVE_SELECTION, BYO_SLIP_ADD_PRICE_TO_STORE, BYO_SLIP_UPDATE_PRICE_TO_STORE, BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE, BYO_SLIP_ADD_SELECTION_TO_STORE, BYO_SLIP_REMOVE_PRICE_FROM_STORE, BYO_SLIP_REMOVE_SELECTION_FROM_STORE, BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE, BYO_ODDS_FORMAT, BYO_SLIP_CLEAR_ALL, BYO_SLIP_STOP_PRICE_UPDATE_SUBSCRIPTION, BYO_SLIP_START_PRICE_UPDATE_SUBSCRIPTION, BYO_SLIP_EXPANDED, BYO_ADD_TO_BETSLIP, BYO_PROCESSING_TO_BETSLIP, BYO_PROCESS_SELECTION, BYO_EDIT_SELECTIONS, BYO_SET_EDIT_ID, BYO_SET_EVENT_ID, BYO_SLIP_SET_LAST_TOPIC, BYO_UPDATE_SELECTIONS_IN_SLIP, BYO_ADD_EXPIRED_SELECTIONS, BYO_MARKETS_CALL_PRICE, BYO_SET_COMPETITION_ID } from '../constants';
export const editSelections = (payload) => ({
    type: BYO_EDIT_SELECTIONS,
    payload,
});
export const expandSlip = (isExpanded) => ({
    type: BYO_SLIP_EXPANDED,
    payload: isExpanded
});
export const addToSlip = (selection) => ({
    type: BYO_ADD_SELECTION,
    payload: selection
});
export const processSelection = (selection) => ({
    type: BYO_PROCESS_SELECTION,
    payload: selection
});
export const updateSelectionsInSlip = (selections) => ({
    type: BYO_UPDATE_SELECTIONS_IN_SLIP,
    payload: selections
});
export const addToBetslip = () => ({
    type: BYO_ADD_TO_BETSLIP,
});
export const processingSelectionToBetslip = (isAddingToBetslip) => ({
    type: BYO_PROCESSING_TO_BETSLIP,
    payload: isAddingToBetslip
});
export const removeFromSlip = (selection) => ({
    type: BYO_REMOVE_SELECTION,
    payload: selection
});
export const stopPriceUpdateSubscription = () => ({
    type: BYO_SLIP_STOP_PRICE_UPDATE_SUBSCRIPTION
});
export const startPriceUpdateSubscription = () => ({
    type: BYO_SLIP_START_PRICE_UPDATE_SUBSCRIPTION
});
export const clearSlip = () => ({
    type: BYO_SLIP_CLEAR_ALL
});
export const addSelectionToStore = (selection) => ({
    type: BYO_SLIP_ADD_SELECTION_TO_STORE,
    payload: selection
});
export const addSelectionToProcessingQueue = (selection) => ({
    type: BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE,
    payload: selection
});
export const removeSelectionFromStore = (selection) => ({
    type: BYO_SLIP_REMOVE_SELECTION_FROM_STORE,
    payload: selection
});
export const removeSelectionFromProcessingQueue = (selection) => ({
    type: BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE,
    payload: selection
});
export const setLastTopic = (topic = null) => ({
    type: BYO_SLIP_SET_LAST_TOPIC,
    payload: topic
});
export const addPrice = (selectionInfo) => ({
    type: BYO_SLIP_ADD_PRICE_TO_STORE,
    payload: selectionInfo
});
export const updatePrice = (selectionInfo) => ({
    type: BYO_SLIP_UPDATE_PRICE_TO_STORE,
    payload: selectionInfo
});
export const setEditID = (id) => ({
    type: BYO_SET_EDIT_ID,
    payload: id
});
export const removePrice = () => ({
    type: BYO_SLIP_REMOVE_PRICE_FROM_STORE
});
export const addOddsFormatToStore = (oddsFormat) => ({
    type: BYO_ODDS_FORMAT,
    payload: oddsFormat
});
export const setEventId = (eventId) => ({
    type: BYO_SET_EVENT_ID,
    payload: eventId,
});
export const setCompetitionId = (competitionId) => ({
    type: BYO_SET_COMPETITION_ID,
    payload: competitionId,
});
export const addExpiredSelections = (selectionIds) => ({
    type: BYO_ADD_EXPIRED_SELECTIONS,
    payload: selectionIds
});
export const callPriceAction = (selections, eventId) => ({
    type: BYO_MARKETS_CALL_PRICE,
    payload: {
        selections,
        eventId,
    }
});
